/**
 * Control Room: samtale med en kundes superadmin (sak 238, trinn 5; migrering 0481).
 *
 * `POST /v1/platform/organizations/:id/conversations` starter en tråd fra Tvitvi-organisasjonen til
 * ett levende medlem av kundens organisasjon. Tråden er en vanlig tråd i Innboks hos begge;
 * plattformadminen ser bare tråder hen selv sitter i.
 *
 * Feltkoder (`VALIDATION_FAILED` + `details[].code`): `unknown_person` (ikke et levende medlem),
 * `self` (seg selv), `platform_organization` (Tvitvi selv), `admin_not_seated` (plattformadminen er
 * ikke medlem av Tvitvi-organisasjonen). En ukjent organisasjon er 404.
 */
import { z } from 'zod';

export const startPlatformConversationRequestSchema = z
  .object({
    personId: z.uuid(),
    /* Samme grenser som en vanlig tråd (`createThreadRequestSchema`). */
    subject: z.string().trim().min(1).max(200),
    body: z.string().trim().min(1).max(20_000),
  })
  .meta({ id: 'StartPlatformConversationRequest' });
export type StartPlatformConversationRequest = z.infer<
  typeof startPlatformConversationRequestSchema
>;

export const startPlatformConversationResponseSchema = z
  .object({ threadId: z.uuid() })
  .meta({ id: 'StartPlatformConversationResponse' });
export type StartPlatformConversationResponse = z.infer<
  typeof startPlatformConversationResponseSchema
>;
